enum AdminTabs {
    General = '/general',
    Features = '/features',
    Terminology = '/terminology',
    Auth = '/authentication',
    Sso = '/sso',
    Users = '/users',
    Integrations = '/integrations',
    ApiKeys = '/api-keys',
    Classes = '/classes',
    Networking = '/networking',
    SuperAdmin = '/super-admin',
    RecordingsTab = '/recordings',
    ZoomSettings = '/zoom-settings',
    VirtualBackgrounds = '/virtual-backgrounds'
}

/** --------------------------------------------------------------------------------
 * !! IF YOU _ADD_ KEYS TO ANY ENUM, YOU MUST UPDATE ALL LOCALIZATION FILES, TOO !!
 * --------------------------------------------------------------------------------- */

enum OrganizationType {
    Academic = 'academic',
    Corporate = 'corporate'
}

enum HostTitle {
    Facilitator = 'facilitator',
    Faculty = 'faculty',
    Instructor = 'instructor',
    Producer = 'producer',
    Professor = 'professor',
    Teacher = 'teacher',
    Trainer = 'trainer',
    Host = 'host'
}

enum AssistantsTitle {
    AdjFacilitator = 'adj_facilitator',
    AdjFaculty = 'adj_faculty',
    Assistant = 'assistant',
    CoHost = 'co_host',
    Faculty = 'faculty',
    Planner = 'planner',
    Producer = 'producer'
}

enum StudentsTitle {
    Learner = 'learner',
    Participant = 'participant',
    Student = 'student'
}

enum RosterTitle {
    Participants = 'participants',
    Roster = 'roster',
    Roll = 'roll'
}

enum GradebookTitle {
    Completions = 'completions',
    Credits = 'credits',
    Feedback = 'feedback',
    Gradebook = 'gradebook',
    Outcomes = 'outcomes',
    Reports = 'reports',
    Results = 'results'
}

enum DocumentTitle {
    Agenda = 'agenda',
    Curriculum = 'curriculum',
    Outline = 'outline',
    Overview = 'overview',
    Program = 'program',
    Rubric = 'rubric',
    Schedule = 'schedule',
    Syllabus = 'syllabus'
}

enum ProctoringTitle {
    Proctoring = 'proctoring_view',
    CollaborationView = 'collaboration_view'
}

export {
    AdminTabs,
    AssistantsTitle,
    DocumentTitle,
    GradebookTitle,
    HostTitle,
    OrganizationType,
    RosterTitle,
    StudentsTitle,
    ProctoringTitle
};
